//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "repairComment",
    data() {
        return {
            radio: '0',
            degree: 0,
            value: '',
            saving: false,
            repairRecordId: 0
        }
    },
    methods: {
        onSave() {
            if (this.repairRecordId == 0) {
                return
            }
            var repairInfo = {
                id: 0,
                repairRecordId: this.repairRecordId,
                repairOperatorType: 5,
                visitResult: parseInt(this.radio),
                degree: this.degree,
                dealWithRemark: this.value,
                file: {associateType: 'RepairInfoFile'},
            };
            if (repairInfo.repairOperatorType == 5) {
                if (repairInfo.visitResult == 1) {
                    repairInfo.repairOperatorType = 4;
                } else {
                    repairInfo.repairOperatorType = 5;
                }
            }

            this.saving = true;
            abp.ajax.post('/api/services/app/RepairRecord/SaveRepairChuLi', repairInfo).then(() => {
                this.$router.back();
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    created() {
        this.repairRecordId = parseInt(this.$route.params.id) || 0;
    }
}
